import React from "react";
import { createRoot } from "react-dom/client";
import { ResponsiveBar } from "@nivo/bar";
import { BasicTooltip } from "@nivo/tooltip";

const TooltipId = ({ label }) => {
  return <span className="capitalize">{label}</span>;
};

const BarChart = ({ data, keys, indexBy, colors, formatStyle, legend }) => {
  let formatterOptions;
  let valueFormat;

  switch (formatStyle) {
    case "currency":
      formatterOptions = {
        style: "currency",
        currency: "USD",
        notation: "compact",
      };
      valueFormat = ">-$";
      break;
    default:
      formatterOptions = {
        notation: "compact",
      };
      valueFormat = ",";
  }

  const theme = {
    axis: {
      legend: {
        text: {
          fontSize: 16,
        },
      },
      ticks: {
        text: {
          fontSize: 14,
        },
      },
    },
  };
  return (
    <>
      <div className="h-[450px] md:h-[550px]">
        <ResponsiveBar
          theme={theme}
          data={data}
          keys={keys ?? []}
          indexBy={indexBy ?? ""}
          colors={colors ?? ["#853AED"]}
          padding={0.3}
          margin={{
            top: 40,
            right: 0,
            bottom: 60,
            left: 60,
          }}
          enableGridX={false}
          enableGridY
          valueFormat={valueFormat}
          enableLabel={false}
          tooltip={(point) => {
            return (
              <BasicTooltip
                key={point.id}
                id={<TooltipId label={`${point.indexValue} - ${point.id}`} />}
                value={`${point.formattedValue}`}
                color={point.color}
                enableChip
              />
            );
          }}
          axisBottom={{
            tickSize: 10,
            tickPadding: 10,
            tickRotation: 0,
            legend: legend ?? "",
          }}
          axisLeft={{
            format: (value) => {
              const formatter = Intl.NumberFormat("en", formatterOptions);
              return formatter.format(value);
            },
          }}
        />
      </div>
    </>
  );
};

const initBarChart = function (selector) {
  const elements = document.querySelectorAll(selector);
  if (elements.length > 0) {
    elements.forEach((element) => {
      const root = createRoot(element);
      const data = JSON.parse(element.dataset.chartdata);
      const keys = JSON.parse(element.dataset.keys);
      const indexBy = element.dataset.indexby;
      const legend = element.dataset.legend;
      const colors = element.dataset.colors
        ? JSON.parse(element.dataset.colors)
        : null;
      const formatStyle = element.dataset.formatstyle;
      root.render(
        <BarChart
          data={data}
          keys={keys}
          indexBy={indexBy}
          colors={colors}
          legend={legend}
          formatStyle={formatStyle}
        />
      );
    });
  }
};

export { BarChart as default, initBarChart };
